/**
 * Iconos distintivos para rubros del sector automotriz
 * Retorna emoji según el nombre del rubro
 */
const ICONOS_RUBROS = {
  'Vulcanización': '🔧',
  'Lavado': '🚿',
  'Talleres mecánicos': '🏭',
  'Pintura': '🎨',
  'Lubricentro': '🛢️',
  'Accesorios': '✨',
  'Grúas': '🚛',
  'Motos': '🏍️',
  'Repuestos': '🔩',
  'Neumáticos': '🛞',
  'Baterías': '🔋',
  'Frenos': '🛑',
  'Eléctrico': '⚡',
  'Carrocería': '🚗',
  'Escapes': '💨',
  'Filtros': '🔍',
  'Herramientas': '🔨',
  'Diagnóstico': '📋',
  'Mantención': '🛠️',
  'Mecánica General': '⚙️',
  'Audio y Alarmas': '🔊',
  'Climatización': '❄️',
  'Transmisión': '⚙️',
  'Suspensión': '🔄',
  'Desarmaduría': '♻️',
  'Electricidad automotriz': '⚡',
  'Enderezado y pintura': '📐',
  'Hojalatería': '🔨',
  'Tapicería': '🪑',
  'Cristales': '🪟',
  'Alineación y balanceo': '⚖️',
  'Inyección diesel': '🛢️',
  'Inyección bencinera': '⛽',
  'Sistema de escape': '💨',
  'Dirección hidráulica': '🎯',
  'Embrague': '⚙️',
  'Frenos ABS': '🛑',
  'Llantas y rines': '🛞',
  'GNC y conversión': '⛽',
  'Automotoras': '🏪',
  'Peritaje': '📄',
  'Patentamiento': '📝',
  'Revisión técnica': '✅',
  'Seguros vehiculares': '🛡️',
  'Grúas y remolques': '🚛',
  'Estacionamientos': '🅿️',
  'Lava autos': '🚿',
  'Detallado': '✨',
  'Polimento': '💎',
  'Ploteo': '🖼️',
  'Tunning': '🚀',
  'Retrofit eléctrico': '🔌',
  'Reciclaje automotriz': '♻️',
  'Partes usadas': '🔧',
  'Importación de vehículos': '🌐',
  'Venta de combustibles': '⛽',
  'Rent a car': '🔑',
  'Aire acondicionado': '❄️',
  'Sistema de enfriamiento': '🌡️',
  'Distribución': '⛓️',
  'Caja de cambios': '⚙️',
  'Diferencial': '⚙️',
  'Amortiguadores': '🔄',
  'Otros': '📌'
};

export const getIconoRubro = (nombre) => {
  if (!nombre || typeof nombre !== 'string') return '🏷️';
  const trimmed = nombre.trim();
  if (ICONOS_RUBROS[trimmed]) return ICONOS_RUBROS[trimmed];
  const key = Object.keys(ICONOS_RUBROS).find(k => k.toLowerCase() === trimmed.toLowerCase());
  return key ? ICONOS_RUBROS[key] : '🏷️';
};

export default ICONOS_RUBROS;
